import { useSelector } from 'react-redux'
import { useCtxDimensions } from '../queries/useCtxDimensions'
import { dimensionStringSelector, dimensionTextSelector } from '../selectors/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { Dimension } from '../types/Dimension'

export const useDimensionListAndFilters = (): [Dimension[], string[]] => {
  const { dimensions: filterDimensions = [] } = useSelector(filtersSelector)
  const { data: dimensionList = [] as Dimension[] } = useCtxDimensions()
  return [dimensionList, filterDimensions]
}

export const useDimensionString = () => {
  const [dimensionList, filterDimensions] = useDimensionListAndFilters()
  return dimensionStringSelector(dimensionList, filterDimensions)
}

export const useDimensionText = () => {
  const [dimensionList, filterDimensions] = useDimensionListAndFilters()
  return dimensionTextSelector(dimensionList, filterDimensions)
}

export const useDimensionQuery = () => {
  const { dimensionsQuery } = useSelector(filtersSelector)
  return dimensionsQuery
}
